import template from './total-area.jade';

export default angular.module('cian.addForm.buildingTotalArea', []).directive('cianAfAboutBuildingTotalArea', () => ({
  scope: {},
  bindToController: {
    ad: '=',
    form: '=',
  },
  controller() {},
  controllerAs: 'buildingTotalArea',
  template,
})).name;
